import { Source, Vector as VectorSource } from 'ol/source';
import { Layer, Vector as VectorLayer } from 'ol/layer';
import { Feature, MapBrowserEvent, Overlay } from 'ol';
import { fromLonLat, transform, transformExtent } from 'ol/proj';
import { Point, Geometry, LineString } from 'ol/geom';
import { Icon, Stroke, Style } from 'ol/style';
import { RenderFunction } from 'ol/style/Style';
import { State } from 'ol/render';
import { FeatureLike } from 'ol/Feature';
import { Map as MGMap } from '@meteogroup/map-layers';
import { smartAge } from '../utils/helpers';
import { VesselsModel } from '../models/vessels-model';
import MGPlayerCore from '@meteogroup/player-core';
import { FiSubView, UiStateModel, UiStateModelParam } from '../models/ui-state-model';
import { AlertId, VesselAlertsModel } from '../models/vessel-alerts-model';
import { trackToFeature } from './utils';
import { PastTrailData, VoyagePastTrailModel, VoyagePastTrailModelEvents } from '../models/voyage-past-trail-model';
import { DragPan} from 'ol/interaction';
import RenderFeature from 'ol/render/Feature';
import '../../local_modules/voyage-past-trail-popup/src/voyage-past-trail-popup';
import { VoyagePastTrailPopup, VoyagePastTrailPopupEvents } from '../../local_modules/voyage-past-trail-popup/src/voyage-past-trail-popup';
import '../../local_modules/voy-map-tooltips/src/voy-map-route-tooltip';
import { VoyMapRouteTooltip } from '../../local_modules/voy-map-tooltips/src/voy-map-route-tooltip';
import { PlanSource ,VoyagePlansModel} from '../models/voyage-plans-model';
import { VoyMapVesselTooltip } from '../../local_modules/voy-map-tooltips/src/voy-map-vessel-tooltip';
import '../../local_modules/voy-map-tooltips/src/voy-map-vessel-tooltip';
import { VoyageSchedulesModel } from '../models/voyage-schedules-model';
import VectorImageLayer from 'ol/layer/VectorImage';
import { getFeatureCenterPosition, handleVectorRerender } from '../utils/map-utils';
import { VoyMapTerminalTooltip } from '../../local_modules/voy-map-tooltips/src/voy-map-terminal-tooltip';
import { drawFocusTriangle, drawHighlightCircle, drawRealLifeSizeVessel, drawVesselWithoutHeading, getNormalVesselIcon, getVesselDrawingCharacteristics, getVesselIconOpacity, resetAndCenter, setVesselStyling } from './map-draw-utils';
import { isPromise } from '../utils/utils';
import { LongArrayProcessingWorker, ProcessingStatus } from '../utils/longArrayProcessingWorker';
import { OperatorId } from '../../local_modules/voy-global-filters/src/types';
import { VoyFleetAlarmModel } from '../models/voy-fleet-alarm-model';
import { VoyageLayersColors, VoyageLayersNames } from './types/voyage-layers.types';
import { VesselsTrackingModel } from '../models/vessels-tracking-model';
import { VesselPositionData, PositionData, VesselCategories } from '../services/types/position-service.types';
import { VesselIconZoomMinimumLevels, VesselIconType } from './types/map-draw-utils.types';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
import { SvgIcons } from '../../local_modules/voyage-svg-icons/src/voyage-svg-icons';
import * as OLExtent from 'ol/extent';
import { FleetFeaturesUtilities } from '../models/fleet-features-utilities';
import { VoyageShoreContextModel } from '../models/voyage-shore-context-model';
import { ExpressionValue } from 'ol/style/expressions';
import { generatePointsFillColors, getVesselIconColor } from '../utils/fleet-point-icon-utils';
import { mapIconSvgs } from './map-styles';
import { VesselProperties } from '../../local_modules/voy-map-tooltips/src/types';
import { VoyPastTrailTable } from  "../../local_modules/voy-past-trail-view/src/voy-past-trail-table";
import { property } from 'lit/decorators';
import { LitElement } from 'lit';


const _PROJECTION = (<any>window)["appenv"].projection;
const _DEFAULT_VESSEL_LENGTH = 280.0;
const _DEFAULT_VESSEL_WIDTH = 40.0;
const _MAX_VESSEL_LENGTH = 450.0;

export class VoyageLayers extends EventTarget {
        private _focusedPosition: any = {};

    constructor(playerCore: MGPlayerCore, options?: VoyageLayersColors) {
        super();
        this._player = playerCore;

        if (options) {
            this.setColors(options);
        }

        this._updateHighlightCircle = this._updateHighlightCircle.bind(this);
        this._updateVesselTrack = this._updateVesselTrack.bind(this);
        this._updateFleetPositions = this._updateFleetPositions.bind(this);
        this._updateSelectedVessel = this._updateSelectedVessel.bind(this);
        this._shipRenderFunction = this._shipRenderFunction.bind(this);
        this._shipHighlightRenderFunction = this._shipHighlightRenderFunction.bind(this);
        this._focusedTrailRenderFunction = this._focusedTrailRenderFunction.bind(this);
        this._updatePastTrail = this._updatePastTrail.bind(this);
        this.assignMap = this.assignMap.bind(this);
        this._onPointerMove = this._onPointerMove.bind(this);
        this._onMapClick = this._onMapClick.bind(this);
        this._closePastTrailPopup = this._closePastTrailPopup.bind(this);
        this._mouseDownOnPastTrailPopup = this._mouseDownOnPastTrailPopup.bind(this);
        this._mouseUpOnPastTrailPopup = this._mouseUpOnPastTrailPopup.bind(this);
        this._onImoChanged = this._onImoChanged.bind(this);
        this._updateFleet = this._updateFleet.bind(this);
        this._vesselIconStyleFunction = this._vesselIconStyleFunction.bind(this);
        this._setVesselRenderFunctionStyle = this._setVesselRenderFunctionStyle.bind(this);
        this._onMoveEnd = this._onMoveEnd.bind(this);
        this._getFeatureRenderPriority = this._getFeatureRenderPriority.bind(this);
        this._setHighlightCircleVisibility = this._setHighlightCircleVisibility.bind(this);
        this._refreshPastTrailTrack = this._refreshPastTrailTrack.bind(this);
        this._setAllFeatures = this._setAllFeatures.bind(this);
        this._foucsTrail = this._foucsTrail.bind(this);
        this._selecTrail = this._selecTrail.bind(this)
    }


    get layers() {
        return this._layers;
    }
    async initialize() {
        // Vessel 'track'
        this._trackVectorSource = new VectorSource();
        this._trackLayer = new VectorLayer({ source: this._trackVectorSource, visible: true });

        // Vessel 'ship' icons
        this.realLifeSizeRendererFunction = new Style({
            renderer: <RenderFunction>this._shipRenderFunction,
        });

        const pointIcon = 'data:image/svg+xml,' + encodeURIComponent(SvgIcons.vesselDot.strings[0])

        this._vesselFeatureSource = new VectorSource();
        this._vesselVectorLayer = new VectorImageLayer({
            source: this._vesselFeatureSource,
            visible: true,
            zIndex: 11,
            style: this.realLifeSizeRendererFunction,
            renderOrder: this._getFeatureRenderPriority
        });

        const webGlPointFillColors = generatePointsFillColors();

        this._pointsLayer = new WebGLPointsLayer({  
            source: this._vesselFeatureSource, 
            visible: true,
            zIndex: 10,
            style: { 
                symbol: {
                    symbolType: 'image',
                    src: pointIcon,
                    size: 10,
                    color: webGlPointFillColors[0] as ExpressionValue[],
                    rotateWithView: false,
                    offset: [0, 0],
                    
                    opacity: ['case', ["==", ['get', 'positionAge'], 3], 0, ["==", ['get', 'positionAge'], 2], 0.4, 1],
                },
            },
            properties: {
                layerName: VoyageLayersNames.WebGlVesselsLayer
            }
        });

        this._borderWebGLLayer = new WebGLPointsLayer({
        source: this._vesselFeatureSource,
        visible: true,
        zIndex: 5,
        style: { 
            symbol: {
                symbolType: 'image',
                src: mapIconSvgs.selectedBorder,
                size: 15,
                rotateWithView: false,
                offset: [0, 0],
                opacity: ['case', ["==", ['get', 'isSelected'], 1], 1, 0],
            },
        }});

        // Vessel 'highlight circle'
        this._vesselHighlightVectorSource = new VectorSource({});
        this._shipHighlightRenderFunctionStyle = new Style({
            renderer: <RenderFunction>this._shipHighlightRenderFunction,
        });
        this._vesselHighlightLayer = new VectorImageLayer({
            source: this._vesselHighlightVectorSource,
            visible: true,
            zIndex: 50, 
            style: this._shipHighlightRenderFunctionStyle,
        });

        const highlightFeature = this._createVesselHighlightFeature();
        this._vesselHighlightVectorSource!.addFeature(highlightFeature);

        //Past trail focus - highlight layer
        this._focusedTrailVectorSource = new VectorSource({});
        this._focusedTrailRenderFunctionStyle = new Style({
            renderer: <RenderFunction>this._focusedTrailRenderFunction,
        });
        this._focusedTrailLayer = new VectorImageLayer({
            source: this._focusedTrailVectorSource,
            visible: true,
            zIndex: 100, // should be on top of all map graphics
            style: this._focusedTrailRenderFunctionStyle,
        });

        const focusedTrialFeature = this._createFocusTrailFeature();
        this._focusedTrailVectorSource!.addFeature(focusedTrialFeature);

        //Past trail
        this._pastTrailVectorSource = new VectorSource({});
        this._pastTrailLayer = new VectorLayer({
            source: this._pastTrailVectorSource,
            visible: false,
            zIndex: 3
        });

        //Past trail popup
        this._pastTrailPopupVectorSource = new VectorSource({});
        this._pastTrailPopupLayer = new VectorLayer({
            source: this._pastTrailPopupVectorSource,
            visible: false,
        });

        this._layers = [this._trackLayer, this._vesselVectorLayer!, this._pointsLayer, this._pastTrailLayer, this._pastTrailPopupLayer, this._borderWebGLLayer,this._vesselHighlightLayer!, this._focusedTrailLayer!];

        // The following should be done in indexedDB with events on sync
        VesselsTrackingModel!.addEventListener('filter-positions-updated', this._updateFleet);
        VesselsModel!.addEventListener('plot-vessel', <EventListener>this._updateSelectedVessel);
        UiStateModel!.addEventListener(`${UiStateModelParam.IMO}-change`, this._onImoChanged);
        VoyagePastTrailModel!.addEventListener(VoyagePastTrailModelEvents.TrackUpdated, <EventListener>this._updatePastTrail);
        VoyagePastTrailModel!.addEventListener(VoyagePastTrailModelEvents.RowFocused, <EventListener>this._foucsTrail);
        VoyagePastTrailModel!.addEventListener(VoyagePastTrailModelEvents.RowSelected, <EventListener>this._selecTrail);
        VesselsTrackingModel?.addEventListener("positions-updated", this._setAllFeatures)
    }

    private _setAllFeatures() {
        FleetFeaturesUtilities!.setAllFeatures(this._allVesselFeatures);
        //this line makes sure that circle is visible after refreshing the page
        this._updateSelectedVessel()
    }

    private _foucsTrail(event:any,data?:any) {
        if(event) this._focusedPosition = event.detail.positionData;
		else this._focusedPosition =data?.positionData;
		
        let sources = [this._focusedTrailVectorSource!]
        if(sources && sources.length) {
            for (const source of sources) {
                const features = source.getFeatures();
                for (let feature of features) {
                    // any focused point in trail other than the current should be reset
                    if (feature.get('layer') === VoyageLayersNames.VesselFocusLayer) {
                        this._focusedTrailVectorSource!.removeFeature(feature);                
                    }
                }
            }
        }

            const focusedPoint = new Feature(new Point([this._focusedPosition?.longitude!,  this._focusedPosition?.latitude!]));
            focusedPoint.getGeometry()?.transform('EPSG:4326', _PROJECTION);
            focusedPoint.setStyle(new Style({
                renderer: <RenderFunction>this._focusedTrailRenderFunction
            }))
            let focusedFeatures = []
            focusedPoint.set("positionData",  this._focusedPosition);
            focusedPoint.set("layer", VoyageLayersNames.VesselFocusLayer);
            focusedPoint.set("imoNo", this._highlightedImo);
            focusedPoint.set("heading",  this._focusedPosition.heading);
			focusedPoint.set("nameFocus",  "focus");

            focusedFeatures.push(focusedPoint); 

        this._focusedTrailVectorSource!.addFeatures(focusedFeatures);
        handleVectorRerender(this._map!, this._setFocusTriangleVisibility, this);
    }

    private _selecTrail(event:any){
        this._openPastTrailPopup(event.detail);
        this._foucsTrail(event);
    }

    private _getFeatureRenderPriority(f: FeatureLike, f2: FeatureLike): number {
        if (f.get('vesselInfo').alarms.length > 0) {
            return 2
        }
        if (f.get('highlight')) {
            return 3
        }
        if (f.get('vesselCategory') == VesselCategories.Maersk) {
            return 1
        }
        return -1;
    }

    private _setVesselRenderFunctionStyle() {
        const zoomLevel = this._zoomLevel;
        if (!zoomLevel) {
            return;
        }
        if (zoomLevel > VesselIconZoomMinimumLevels.REAL_LIFE) {
            this._pointsLayer?.setOpacity(0);
            this._borderWebGLLayer?.setOpacity(0);
            this._vesselVectorLayer?.setStyle(this.realLifeSizeRendererFunction);
            this._vesselVectorLayer?.setVisible(true);
        } else if (zoomLevel > VesselIconZoomMinimumLevels.NORMAL) {
            this._pointsLayer?.setOpacity(0);
            this._borderWebGLLayer?.setOpacity(0);
            this._vesselVectorLayer?.setStyle(this._vesselIconStyleFunction);
            this._vesselVectorLayer?.setVisible(true);
        } else {
            this._vesselVectorLayer?.setVisible(true);
            this._vesselVectorLayer?.setStyle(this._vesselIconStyleFunction);
            this._pointsLayer?.setOpacity(1);
            this._borderWebGLLayer?.setOpacity(1);
        }
    }

    private _vesselIconStyleFunction(feature: FeatureLike): Style {
        if (!this._zoomLevel) {
            return new Style();
        }
        const positionAge = feature.get('positionAge')
        const hasAlarms = feature.get('vesselInfo').alarms.length > 0;
        const isMaersk = feature.get('isMaersk');
        const heading = feature.get('heading');
        const theading = (heading) * Math.PI / 180;
        const isHighlighted = feature.get('highlight');
        let icon: Style|null = null;
        if (this._zoomLevel < VesselIconZoomMinimumLevels.NORMAL && isHighlighted) {
            icon = getNormalVesselIcon(feature.get("vesselCategory")!, feature.get("isSelected")!, heading);
            icon.getImage().setRotation(theading);
        } else if (this._zoomLevel >= VesselIconZoomMinimumLevels.NORMAL && this._zoomLevel <= VesselIconZoomMinimumLevels.REAL_LIFE) {
            icon = getNormalVesselIcon(feature.get("vesselCategory")!, feature.get("isSelected")!, heading);
            icon.getImage().setRotation(theading);
        }

        if (!icon) {
            return new Style();
        }
        icon.getImage().setOpacity(getVesselIconOpacity(positionAge, isMaersk))

        return icon;
    }

    private _createTooltipOverlay(element: HTMLElement) {
        const overlay = new Overlay({
            position: fromLonLat([0, 0], _PROJECTION),
            positioning: 'bottom-center',
            element: element,
            stopEvent: false,
        });
        this._map?.addOverlay(overlay);
        return overlay;
    }

    setColors(colors: VoyageLayersColors) {
        this._colors = colors;
    }

    assignMap(map: MGMap) {
        this._map = map;
        this._tooltipElement = <VoyMapVesselTooltip>window.document.createElement('voy-map-vessel-tooltip');
        this._mapRouteTooltipElement = <VoyMapRouteTooltip>window.document.createElement('voy-map-route-tooltip');
        this._tooltipOverlay = this._createTooltipOverlay(this._tooltipElement);
        this._mapRouteTooltipOverlay = this._createTooltipOverlay(this._mapRouteTooltipElement);
        this._createPortPinTooltip();

        this._map.on('moveend', () => this._onMoveEnd());
        this._map.on('pointermove', this._onPointerMove);

        const zoomLevel = this._map.getView().getZoom();
        if (zoomLevel) {
            this._zoomLevel = zoomLevel;
            this._setVesselRenderFunctionStyle();
        }
        this._onImoChanged();
        handleVectorRerender(this._map, this._enablePastTrailTrack, this)
    }

    clearVoyage() {
        try {
            // clear all except for ship vector, that is explicitly cleared when rendering fleet on map
            if (this._trackVectorSource) this._trackVectorSource.clear();
        } catch (error) {
            console.warn(error);
        }
    }

    private _layers: Layer<Source>[] = [];
    private _player: MGPlayerCore;
    private _colors: VoyageLayersColors = {
        trackColor: "grey",
        pastTrailMarkerColor: "red",
        pastTrailLineColor: "black",
        pastTrailHighlightedMarkerColor: "blue",
        highlightCircleColor: "red",
        vesselIconAlarmColor: "red",
        vesselIconColor: "blue",
        positionWarningMarkerWarnColor: "yellow",
        positionWarningMarkerErrorColor: "red",
        nonMaerskVesselIconColor: "yellow",
    };
    private _drawingFleetOnMap: boolean = false;
    private _drawingFleetPromise: Promise<void> | null = null;
    private _trackVectorSource: VectorSource<Geometry> | null = null;
    private _vesselFeatureSource: VectorSource<Point> | null = null;
    private _vesselHighlightVectorSource: VectorSource<Geometry> | null = null;
    private _focusedTrailVectorSource: VectorSource<Geometry> | null = null;
    private _pastTrailVectorSource: VectorSource<Geometry> | null = null;
    private _pastTrailPopupVectorSource: VectorSource<Geometry> | null = null;
    private _trackLayer: VectorLayer<VectorSource<Geometry>> | null = null;
    private _vesselVectorLayer: VectorImageLayer<VectorSource<Point>> | null = null;
    private _pointsLayer: WebGLPointsLayer<VectorSource<Point>> | null = null;
    private _vesselHighlightLayer: VectorImageLayer<VectorSource<Geometry>> | null = null;
    private _focusedTrailLayer: VectorImageLayer<VectorSource<Geometry>> | null = null;
    private _pastTrailLayer: VectorLayer<VectorSource<Geometry>> | null = null;
    private _pastTrailPopupLayer: VectorLayer<VectorSource<Geometry>> | null = null;
    private _knownVessels: Set<number> = new Set();
    private _map: MGMap | null = null;
    private _desiredScale: number = 1.0;
    private realLifeSizeRendererFunction: Style | null = null;
    private _shipHighlightRenderFunctionStyle: Style | null = null;
    private _focusedTrailRenderFunctionStyle: Style | null = null;
    private _pastTrailSelectedFeature: RenderFeature | Feature<Geometry> | null = null;
    private _pastTrailDragPan: DragPan | null = null;
    private _pastTrailMouseDeltaX: number = 0;
    private _pastTrailMouseDeltaY: number = 0;
    private _pastTrailDraggedOverlay: Overlay | null = null;
    private _pastTrailOpenedPopups: Set<VoyagePastTrailPopup> = new Set<VoyagePastTrailPopup>();
    private _tooltipElement: VoyMapVesselTooltip | null = null;
    private _tooltipOverlay: Overlay | null = null;
    private _mapRouteTooltipElement: VoyMapRouteTooltip | null = null;
    private _mapRouteTooltipOverlay: Overlay | null = null;
    private _portPinTooltipElement: VoyMapTerminalTooltip | null = null;
    private _portPinTooltipOverlay: Overlay | null = null;
    private _moveCount: number = 0;
    private _zoomLevel: number | null = null;
    private _highlightedImo: number | null = null;
    private _highlightedFeature: Feature<Geometry> | null = null;
    private _featureCreationWorker = new LongArrayProcessingWorker();
    private _updateFleetInQueue: boolean = false;
    private _allVesselFeatures: Map<number, Feature<Point>> = new Map();
    private _borderWebGLLayer: WebGLPointsLayer<VectorSource<Point>> | null = null;
	private _pastTrailLayerData : PastTrailData | null = null;
	private _toolTipData: Array<PastTrailData> = []


    private _shipRenderFunction(coords: number[], state: State): void {
        if (!this._map || !this._zoomLevel) {
            return;
        }
        const { context: ctx, feature, resolution } = state;

        const drawingOptions = { maxVesselLength: _MAX_VESSEL_LENGTH, resolution, map: this._map, desiredScale: this._desiredScale, zoom: this._zoomLevel };
        const drawingCharacteristics = getVesselDrawingCharacteristics(feature, drawingOptions);
        const { heading, theading, drawInReallifeSize, positionAge, hasAlarms, resolutionScale, isMaersk, isSelected } = drawingCharacteristics;
        let { length, width } = drawingCharacteristics;

        ctx.save();

        const fillColor = getVesselIconColor(feature.get("imoNo"));

        const options = { drawInReallifeSize, hasAlarms, fillColor, positionAge, isMaersk, isSelected };
        setVesselStyling(ctx, options);
        resetAndCenter(ctx, coords);

        switch (this._getIconType(heading)) {
            case VesselIconType.RealLifeSize:
                length *= resolutionScale;
                width *= resolutionScale;
                const realLifeSizeOptions = { theading, drawLength: length, drawWidth: width, bowOffset: length / 3, resolution, isSelected }
                drawRealLifeSizeVessel(ctx, realLifeSizeOptions);
                break;

            case VesselIconType.MissingHeading:
                length *= resolutionScale;
                width *= resolutionScale;
                drawVesselWithoutHeading(ctx, width, isSelected)
                break;

            default:
                console.error("Error getting vessel icon type. Cannot draw vessel on map ", "Heading: ", heading, " - ", "drawInRealLifeSize: ", drawInReallifeSize)
                return;
        }

        ctx.restore();
    }

    private _shipHighlightRenderFunction(coords: number[], state: State): void {
        const { context: ctx, feature, resolution } = state;

        // If vessel properties have not been received, return.
        // Vessel properties comes from _updateHighlightCircle
        if (!feature.get("imoNo" || !this._map || this._zoomLevel)) {
            return;
        }

        const drawingOptions = { maxVesselLength: _MAX_VESSEL_LENGTH, resolution, map: this._map, desiredScale: this._desiredScale, zoom: this._zoomLevel };
        const drawingCharacteristics = getVesselDrawingCharacteristics(feature, drawingOptions);
        const { heading, theading, drawInReallifeSize, resolutionScale } = drawingCharacteristics;
        let { length, width, scaleFactor } = drawingCharacteristics;

        ctx.save();

        let circleRadius = 0;
        let circleOffset = 0;

        if (drawInReallifeSize) {
            if (heading) {
                circleRadius = length * resolutionScale + 10;
            } else {
                circleRadius = length * resolutionScale / 5;
            }
        }
        if (!drawInReallifeSize) {
            if (heading) {
                circleRadius = length * scaleFactor * 2 + 8;
            } else {
                circleRadius = length * scaleFactor + 10;
            }
        }

        const options = { length, width, circleOffset, circleRadius, coords, theading, drawInReallifeSize, highlightCircleColor: this._colors.highlightCircleColor };
        drawHighlightCircle(ctx, options);

        ctx.restore();
    }

    private _focusedTrailRenderFunction(coords: number[], state: State): void {
        const { context: ctx, feature, resolution } = state;
        if (!feature.get("imoNo" || !this._map || this._zoomLevel)) {
            return;
        }
        if (!this._focusedPosition) {
            return;
        }
        const drawingOptions = { maxVesselLength: _MAX_VESSEL_LENGTH, resolution, map: this._map, desiredScale: this._desiredScale, zoom: this._zoomLevel };
        const drawingCharacteristics = getVesselDrawingCharacteristics(feature, drawingOptions);
        const { theading } = drawingCharacteristics;

        ctx.save();

        const options = { length:5, width:8, coords, theading, highlightColor: "black" ,fillColor:"#B5E0F5"};
        drawFocusTriangle(ctx, options);

        ctx.restore();
    }

    private _getIconType(heading: number) {
        if (heading) {
            return VesselIconType.RealLifeSize;
        }
        return VesselIconType.MissingHeading;
    }

    private async _updateFleet() {
        if (this._updateFleetInQueue) return;
        // cancel out of and clean up any ongoing and queued processing
        if (this._drawingFleetPromise && isPromise(this._drawingFleetPromise, this)) {
            this._updateFleetInQueue = true;
            if (this._featureCreationWorker.status === ProcessingStatus.InProgress) {
                await this._featureCreationWorker.stopProcessing();
            }
            await this._drawingFleetPromise;
            this._updateFleetInQueue = false;
            this._drawingFleetPromise = this._updateFleetPositions();
            return;
        }
        this._drawingFleetPromise = this._updateFleetPositions();
    }

    private async _updateFleetPositions() {
        this._drawingFleetOnMap = true;
   
        this._vesselFeatureSource!.clear(true);
       
        const filteredFeatures = FleetFeaturesUtilities.getFilteredFeatures(this._allVesselFeatures);
       
        this._vesselFeatureSource!.addFeatures(filteredFeatures);
        
        const filteredFeaturesCombined = filteredFeatures;
        const coords: number[][] = []
        for (const vessel of filteredFeaturesCombined) {
            const vesselCoords = vessel.getGeometry()!.getCoordinates();
            coords.push(vesselCoords);
        }

        this._adjustMapView(coords);

        this._scaleShipShapes();
        this._drawingFleetOnMap = false;
    }

    private _adjustMapView(coords: number[][]) {
        if (!VoyageShoreContextModel!.shouldUpdateFilterMapView) return;

        if (!coords.length) return;
        // for defining box, we need to modify box lines crossing the dateline so point 'train' is continuous.
        const continousLon = (lon1: number, lon2: number) => {
            if (Math.abs(lon2 - lon1) > 180) {
                return lon2 + Math.sign(lon1) * 360;
            }
            return lon2;
        }

        // input coordinates in EPSG:4326 / WGS84
        const extent = OLExtent.boundingExtent(coords.map((c) => {
            let lastLon: number = coords[0][0];
            let coord = c;
            lastLon = continousLon(lastLon, coord[0]);
            coord = [lastLon, coord[1]];
            return coord;
        }));
        this._map!.getView().fit(OLExtent.buffer(extent, 2000), { duration: 250, padding: [0, 0, 0, 200] });
        VoyageShoreContextModel!.setShouldUpdateFilterMapView(false);
    }

    // Scales the size of the ships based on how many are currently in the viewport
    private _scaleShipShapes() {
        const scale = this._getDesiredScale();
        if (!scale) return;
    }

    private _createVesselHighlightFeature(): Feature<Geometry> {

        const shipPoint = new Point([0, 0]);
        const shipFeature = new Feature({
            geometry: shipPoint,
        });
        shipFeature.setId("highlight");

        return shipFeature;
    }

    private _createFocusTrailFeature(): Feature<Geometry> {

        const shipPoint = new Point([0, 0]);
        const shipFeature = new Feature({
            geometry: shipPoint,
        });
        shipFeature.setId("focus");

        return shipFeature;
    }

     // mormalises target coordinates to handle International Date Line crossing, that takes shortest path accross IDL
    private _normalizePositionForIDL(targetPosition: number[]): number[] {
        if (!this._map) {
            return targetPosition;
        }

        const currentCenter = this._map.getView().getCenter()!;
        
        const currentCenterLonLat = transform(currentCenter, _PROJECTION, 'EPSG:4326');
        const targetLonLat = transform(targetPosition, _PROJECTION, 'EPSG:4326');
        
        const currentLon = currentCenterLonLat[0];
        const targetLon = targetLonLat[0];
        
        let lonDiff = targetLon - currentLon;
        
        // if the difference is greater than 180°, we should go the other way around the world
        if (lonDiff > 180) {
            targetLonLat[0] = targetLon - 360;
        } else if (lonDiff < -180) {
            targetLonLat[0] = targetLon + 360;
        }
        
        return transform(targetLonLat, 'EPSG:4326', _PROJECTION);
    }

    private _updateSelectedVessel() {
        if (this._drawingFleetOnMap) {
            return;
        }

        this._drawingFleetOnMap = true;

        if (!this._highlightedImo) {
            if (this._highlightedFeature) {
                this._highlightedFeature.setProperties({ 'highlight': false });
                this._highlightedFeature.changed();
            }
            this._drawingFleetOnMap = false;
            return;
        }

        // TODO: When refreshing browser, features do not exist. This means a selected vessel won't
        // TODO: get the red circle. Solution would be to call the rest of this function in a callback,
        // TODO: when the features are not loaded on refresh
        if (!this._allVesselFeatures.size) {
            return;
        }

        const highlightedFeature = this._allVesselFeatures.get(this._highlightedImo)!;
        if (!this._vesselFeatureSource!.hasFeature(highlightedFeature)) {
            this._vesselFeatureSource?.addFeature(highlightedFeature);
        }
        
        // getting the target position and normalising it to handle IDL crossing
        const targetPosition = getFeatureCenterPosition(highlightedFeature, this._map!);
        const normalizedPosition = this._normalizePositionForIDL(targetPosition);
        
        this.dispatchEvent(new CustomEvent('center-at', { detail: normalizedPosition }));
        this._handleHighlightFeatures([this._vesselFeatureSource!]);
        this._drawingFleetOnMap = false;
    }

    private _handleHighlightFeatures(sources: VectorSource<Geometry>[]) {
        const highlightExists = this._vesselHighlightLayer?.getVisible();
        let previousHighlightHandled = false;
        let newHighlightHandled = false;

        for (const source of sources) {
            const features = source.getFeatures();
            for (let feature of features) {
                // any highlighted vessel other than one being plotted should be reset
                if (feature.get('highlight') && feature.getId() != this._highlightedImo) {
                    feature.setProperties({ 'highlight': false });
                    previousHighlightHandled = true;
                }

                if (feature.getId() == this._highlightedImo) {
                    feature.setProperties({ highlight: true });
                    this._highlightedFeature = feature;
                    this._updateHighlightCircle(<Feature<Point>>feature);
                    newHighlightHandled = true;
                }

                // if features are handled, stop searching and return
                if (!highlightExists) {
                    if (newHighlightHandled) return;
                } else {
                    if (newHighlightHandled && previousHighlightHandled) return;
                }
            }
        }
    }

    // Update highlight circle based on selected vessel
    private _updateHighlightCircle(vesselFeature: Feature<Point>) {
        const properties = vesselFeature.getProperties();
        const coords = vesselFeature.getGeometry()!.getCoordinates();
        const highlightCircle = <Feature<Point>>this._vesselHighlightVectorSource!.getFeatureById("highlight");

        highlightCircle?.getGeometry()?.setCoordinates(coords);
        highlightCircle.setProperties({
            imoNo: properties.imoNo,
            highlight: true,
            length: properties.length || _DEFAULT_VESSEL_LENGTH,
            width: properties.width || _DEFAULT_VESSEL_WIDTH,
            heading: properties.heading,
            positionAge: properties.positionAge,
            layer: VoyageLayersNames.VesselHighlightLayer,
            vesselInfo: properties.vesselInfo,
        })
        this._vesselHighlightLayer?.changed();
        handleVectorRerender(this._map!, this._setHighlightCircleVisibility, this);
    }

    private _setHighlightCircleVisibility() {
        this._vesselHighlightLayer?.setVisible(true);
    }

    private _setFocusTriangleVisibility() {
        this._focusedTrailLayer?.setVisible(true)
    }

    private _updateVesselTrack(evt: CustomEvent) {
        // Abort plotting the track if the selected vessel has changed in the meantime
        if ((UiStateModel!.getValue('imo') || 0) != evt.detail.imoNo) {
            return;
        }

        const tracking = VesselsTrackingModel!.getTracking(evt.detail.imoNo);
        if (!tracking) {
            return;
        }
        const lastPos = tracking.positions[tracking.positions.length - 1];
        this._plotTrack(tracking.positions, `Track for: ${evt.detail.imoNo}`, this._colors.trackColor);
    }

    private _plotTrack(data: PositionData[], label: string, lineColor: string) {
        const features = trackToFeature(data, lineColor, label);
        this._trackVectorSource!.clear();
        this._trackVectorSource!.addFeatures(features);
    }

    private _onMoveEnd() {
        const newZoomLevel = this._map?.getView().getZoom();
        if (newZoomLevel && newZoomLevel !== this._zoomLevel) {
            this._zoomLevel = newZoomLevel;
            this._setVesselRenderFunctionStyle();
        }

        this._getDesiredScale();
    }

    // returns desired scale for size of ships and desired scale for highlighted vessel
    private _getDesiredScale() {
        if (!this._map) {
            return;
        }

        // Get the currently visible extent as lat/lng and normalize it so the left edge is between -180 and 180
        let extent = transformExtent(this._map.getView().calculateExtent(this._map.getSize()), _PROJECTION, 'EPSG:4326');
        while (extent[0] < -180) {
            extent[0] += 360;
            extent[2] += 360;
        }
        while (extent[0] > 180) {
            extent[0] -= 360;
            extent[2] -= 360;
        }

        // Add features visible in the normalized extent
        let displayedFeatures = this._vesselFeatureSource!.getFeaturesInExtent(transformExtent(extent, 'EPSG:4326', _PROJECTION)).length;

        // If the normalized extent spans the dateline, also add features from the other side
        if (extent[2] > 180) {
            extent[0] -= 360;
            extent[2] -= 360;
            displayedFeatures += this._vesselFeatureSource!.getFeaturesInExtent(transformExtent(extent, 'EPSG:4326', _PROJECTION)).length;
        }

        let desiredScale = displayedFeatures > 600 ? 0.7 : 1.0;

        this._desiredScale = desiredScale;

        this._vesselVectorLayer?.changed();
        this._vesselHighlightLayer?.changed();

        return this._desiredScale;
    }


    private _enablePastTrailTrack() {
        if (this._pastTrailLayer?.getVisible()) {
            return;
        }

        this._trackLayer?.setVisible(false);
        this._pastTrailLayer!.setVisible(true);
        this._pastTrailPopupLayer!.setVisible(true);

        if (this._map) {
            this._map.on('click', this._onMapClick);
            this._pastTrailDragPan = <DragPan>this._map.getInteractions()
                .getArray()
                .find(interaction => interaction instanceof DragPan) || null;
        }
    }

    private _disablePastTrailTrack() {
        this._pastTrailVectorSource!.clear();
        this._trackVectorSource!.clear();
        this._trackLayer?.setVisible(true);
        this._pastTrailLayer!.setVisible(false);
        this._focusedTrailLayer!.setVisible(false);
        this._pastTrailPopupLayer!.setVisible(false);
        this._pastTrailOpenedPopups.forEach(el => el.dispatchEvent(new Event(VoyagePastTrailPopupEvents.Close)));
        this._pastTrailOpenedPopups.clear();
        this._pastTrailPopupVectorSource?.clear();
    }

    private _onImoChanged() {
        this._disablePastTrailTrack();

        const imoString = UiStateModel!.getValue(UiStateModelParam.IMO);
        if (imoString) {
            this._highlightedImo = parseInt(imoString, 10);
            this._refreshPastTrailTrack(this._highlightedImo);
            handleVectorRerender(this._map!, this._enablePastTrailTrack, this);
        } else {
            this._highlightedImo = null;
            this._vesselHighlightLayer?.setVisible(false);
        }

        this._updateSelectedVessel();
    }

    private _refreshPastTrailTrack(imo: number) {
        const scheduleInfo = VoyageSchedulesModel?.currentScheduleStates?.find(s => s.imoNo === imo)
        if (scheduleInfo) {
            VoyagePastTrailModel!.createPastTrailSegment(imo, scheduleInfo.schedule.startTime, Date.now());
        }
        // if schedule is not available - fetching past trail for the last three days
        else {
            let  fromDateForTrail = new Date();
            fromDateForTrail.setDate(fromDateForTrail!.getDate() - 3);
            VoyagePastTrailModel!.createPastTrailSegment(imo, fromDateForTrail.getTime(), Date.now());
        }         

        const isNonMaerskVessel = VesselsModel!.getVessel(imo)?.operatorCode === OperatorId.NonMSK;
        if(isNonMaerskVessel) {
            let fromDate = new Date();
            fromDate.setDate(fromDate!.getDate() - 3);
            VoyagePastTrailModel!.createPastTrailSegment(imo, fromDate.getTime(), Date.now());
        }
    }

    private _onMapClick(e: MapBrowserEvent<any>) {
        this._map!.forEachFeatureAtPixel(e.pixel, (f: RenderFeature | Feature<Geometry>) => {
            const hasFeaturesFromClusteredLayer = f.get('features') ? f.get('features').length > 0 : false;
            const layerName = hasFeaturesFromClusteredLayer ? f.get('features')[0].get('layer') : f.get("layer");
	    if (layerName === VoyageLayersNames.VesselFocusLayer) {
                if (this._pastTrailLayerData) {
                    this._openPastTrailPopup(this._pastTrailLayerData);
                }
            }
            if (layerName === VoyageLayersNames.PastTrailLayer) {
                const positionData = <PastTrailData>f.get("positionData");
                if (positionData) {
                   this._openPastTrailPopup(positionData);
                    const style = this._pastTrailMarkerStyle(positionData, this._colors.pastTrailMarkerColor, 1.2);
                    (<Feature<Geometry>>f).setStyle(style);
                }
            }
            if (layerName === VoyageLayersNames.TerminalPortLayer) {
                UiStateModel!.setValue(UiStateModelParam.IMO);
                const features = f.get('features');

                if (features.length === 1) {
                    const terminal = features[0].get('properties')
                    this.dispatchEvent(new CustomEvent('center-at', { detail: getFeatureCenterPosition(features[0], this._map!) }));
                    this._map?.getView().animate({ zoom: 14 });
                    UiStateModel!.setValue(UiStateModelParam.FISubView, FiSubView.PortView);
                    UiStateModel!.setValue(UiStateModelParam.PORT, terminal.cityId);
                }
            }

            return true;
        });
    }

    private _onPointerMove(e: MapBrowserEvent<UIEvent>) {
        if (this._map!.getProperties().isMoving) {
            return
        }
        // Process every 5 move events only
        this._moveCount++;
        if (this._moveCount != 5) { return; }
        this._moveCount = 0;

        // as long as tooltip is being hovered, don't remove it
        if (e.originalEvent.target === this._portPinTooltipElement) {
            return;
        }

        this._tooltipElement!.visible = false;
        this._mapRouteTooltipElement!.visible = false;
        this._portPinTooltipElement!.visible = false;
        let tooltipText = "";
        
        if (this._pastTrailSelectedFeature !== null && this._pastTrailSelectedFeature.get("positionData")) {
            const data = <PastTrailData>this._pastTrailSelectedFeature.get("positionData");
            (<Feature<Geometry>>this._pastTrailSelectedFeature).setStyle(this._pastTrailMarkerStyle(data, this._colors.pastTrailMarkerColor, 0.85));
            this._pastTrailSelectedFeature = null;
        }
        const vessels: Array<Feature<Geometry> | RenderFeature> = [];

        this._map!.forEachFeatureAtPixel(e.pixel, (f: RenderFeature | Feature<Geometry>) => {
            const hasFeaturesFromClusteredLayer = f.get('features') ? f.get('features').length > 0 : false;
            const layerName = hasFeaturesFromClusteredLayer ? f.get('features')[0].get('layer') : f.get("layer");
              
            if (layerName === "pastTrailPosition") {
                this._pastTrailSelectedFeature = f;
                const data = <PastTrailData>this._pastTrailSelectedFeature.get("positionData");
                //higlitong pasttrail 
                (<Feature<Geometry>>f).setStyle(this._pastTrailMarkerStyle(data, this._colors.pastTrailHighlightedMarkerColor, 1.5));
            }
            if (layerName === VoyageLayersNames.PastTrailLayer) {
                 //highlighting pastrail 
                const isGap = hasFeaturesFromClusteredLayer ? f.get('features')[0].get('isGap') : f.get("isGap");
                this._pastTrailSelectedFeature = f;
                const data = <PastTrailData>this._pastTrailSelectedFeature.get("positionData");
                tooltipText = `Past Trail${isGap ? " (missing position data)" : ""}`
                VoyagePastTrailModel!.highlightTableOnPastTrailClick(data)
				// focus highlight in trail
				this._pastTrailLayerData = <PastTrailData>this._pastTrailSelectedFeature.get("positionData");;
				this._foucsTrail(undefined, data)
            }
            if (layerName === VoyageLayersNames.VesselsLayer) {
                vessels.push(f)
            }
            if (layerName === VoyageLayersNames.PlanLayer) {
                if (f.getGeometry() instanceof Point && f.get("type") === "Hard") {
                    tooltipText = hasFeaturesFromClusteredLayer ? f.get('features')[0].get('wpInfo') : f.get("wpInfo");
                }
                if (f.getGeometry() instanceof LineString) {
                    
                    const plans = VoyagePlansModel!.getPlans(this._highlightedImo!);
                    plans!.get(PlanSource.EXCEL_PLAN)
                    let planSource = hasFeaturesFromClusteredLayer ? f.get('features')[0].get('planSource') : f.get("planSource");
                    if( planSource === PlanSource.EXCEL_PLAN ){
                        const plan_excel = plans!.get(PlanSource.EXCEL_PLAN)
                        if( plan_excel?.routes.length!=0 && plan_excel!.selectedRouteIndex>=0 && plan_excel!.selectedRouteIndex < plan_excel!.routes.length ){
                          planSource  = PlanSource.VOYAGE_BASIC_ROUTE_NOT_OPTIMIZED
                        }
                    }
                    switch (planSource) {
                        case PlanSource.PASSAGE_PLAN:
                            tooltipText = "Plan (email)"
                            break;
                        case PlanSource.ECOVOYAGE:
                            tooltipText = "Plan (EcoVoyage)"
                            break;
                        case PlanSource.EXCEL_PLAN:
                            tooltipText = "Plan (Excel)"
                            break;
                        case PlanSource.VOYAGE_PLANNING:
                            tooltipText = "Plan Vessel Voyage"
                            break;
                        case PlanSource.VOYAGE_BASIC_ROUTE_NOT_OPTIMIZED:
                            tooltipText = "Voyage Basic - Route(not optimized)"
                            break;
                    }
                }
            }

            if (layerName === VoyageLayersNames.TerminalPortLayer) {
                const features = f.get('features');
                if (features.length > 0) {
                    //Show voy-map-terminal-tooltip
                    const coordinates = getFeatureCenterPosition(f as Feature<Point>, this._map!)

                    this._portPinTooltipOverlay!.setPosition(coordinates);

                    const grouppedTerminalsByCity = this._groupTerminalsByCity(features);

                    this._portPinTooltipElement!.visible = true;
                    this._portPinTooltipElement!.groupedTerminals = grouppedTerminalsByCity;
                }
            }
            return true;
        });

        let pixelCoords = this._map!.getCoordinateFromPixel(e.pixel);
        if (tooltipText !== "") {
            this._mapRouteTooltipOverlay!.setPosition(pixelCoords);
            this._mapRouteTooltipElement!.visible = true;
            this._mapRouteTooltipElement!.text = tooltipText;
        } else {
            this._mapRouteTooltipElement!.visible = false;
        }

        if (vessels.length > 0 && vessels[0]) {
            const vesselCoors = getFeatureCenterPosition(vessels[0] as Feature<Point>, this._map!);
            this._tooltipOverlay!.setPosition(vesselCoors);
            this._tooltipElement!.visible = true;
            this._tooltipElement!.vesselProperties = vessels[0].getProperties() as VesselProperties;
            const imo = vessels[0].getProperties().imoNo;
            this._tooltipElement!.vesselProperties!.vesselInfo.name = VesselsModel!.getVesselName(imo) || "";

        } else {
            this._tooltipElement!.visible = false;
        }

        const getAdjustedCoords = (coordinate: number[]) => {
            const resultCoord = [coordinate[0] - this._pastTrailMouseDeltaX, coordinate[1] - this._pastTrailMouseDeltaY / 2];
            return resultCoord;
        }

        if (this._pastTrailDraggedOverlay) {
            if (this._pastTrailDraggedOverlay.get('dragging') === true) {
                this._pastTrailDraggedOverlay.setPosition(getAdjustedCoords(e.coordinate));

                let lineCoordinatesAtPopup = this._pastTrailDraggedOverlay.getPosition()!;
                const lineFeature: Feature<LineString> = this._pastTrailDraggedOverlay.get("lineFeature");
                const lineCoordinates = lineFeature.getGeometry()?.getCoordinates();
                const linePixelCoordinatesAtPopup = this._map!.getPixelFromCoordinate(lineCoordinatesAtPopup);
                const pastTrailPositionOnMapPixelCoordinates = this._map!.getPixelFromCoordinate(lineCoordinates![0]);
                const popup = this._pastTrailDraggedOverlay.getElement()!;

                // TS ignore is used because OpenLayers wrapps the elements in some custom div, so they have width and height equal 0
                // @ts-ignore
                const clientWidth = popup.parentNode?.clientWidth;
                // @ts-ignore
                const clientHeight = popup.parentNode?.clientHeight;

                const dx = pastTrailPositionOnMapPixelCoordinates[0] - (linePixelCoordinatesAtPopup[0] + clientWidth / 2);
                const dy = pastTrailPositionOnMapPixelCoordinates[1] - (linePixelCoordinatesAtPopup[1] + clientHeight / 2);
                // Divides the cirle into 16 sections (360deg / 22.5 = 16) and assign the line based on its angle to one of them
                const lineAngleSectionOnCircle = Math.atan2(dx, dy) * 180 / Math.PI / 22.5;

                // Set the correct corner where the line is attached to pop up from position coordinates.
                if (lineAngleSectionOnCircle >= -1 && lineAngleSectionOnCircle <= 1) {
                    linePixelCoordinatesAtPopup[0] = linePixelCoordinatesAtPopup[0] + clientWidth / 2;
                    linePixelCoordinatesAtPopup[1] = linePixelCoordinatesAtPopup[1] + clientHeight;
                }
                if (lineAngleSectionOnCircle < -1 && lineAngleSectionOnCircle > -3) {
                    linePixelCoordinatesAtPopup[1] = linePixelCoordinatesAtPopup[1] + clientHeight;
                }
                if (lineAngleSectionOnCircle >= -5 && lineAngleSectionOnCircle <= -3) {
                    linePixelCoordinatesAtPopup[1] = linePixelCoordinatesAtPopup[1] + clientHeight / 2;
                }
                if (lineAngleSectionOnCircle <= -7 || lineAngleSectionOnCircle >= 7) {
                    linePixelCoordinatesAtPopup[0] = linePixelCoordinatesAtPopup[0] + clientWidth / 2;
                }
                if (lineAngleSectionOnCircle < 7 && lineAngleSectionOnCircle > 5) {
                    linePixelCoordinatesAtPopup[0] = linePixelCoordinatesAtPopup[0] + clientWidth;
                }
                if (lineAngleSectionOnCircle <= 5 && lineAngleSectionOnCircle >= 3) {
                    linePixelCoordinatesAtPopup[0] = linePixelCoordinatesAtPopup[0] + clientWidth;
                    linePixelCoordinatesAtPopup[1] = linePixelCoordinatesAtPopup[1] + clientHeight / 2;
                }
                if (lineAngleSectionOnCircle < 3 && lineAngleSectionOnCircle > 1) {
                    linePixelCoordinatesAtPopup[0] = linePixelCoordinatesAtPopup[0] + clientWidth;
                    linePixelCoordinatesAtPopup[1] = linePixelCoordinatesAtPopup[1] + clientHeight;
                }

                lineCoordinatesAtPopup = this._map?.getCoordinateFromPixel(linePixelCoordinatesAtPopup)!;

                lineFeature.getGeometry()?.setCoordinates([lineCoordinates![0], lineCoordinatesAtPopup])
            }
        }
    }

    private _openPastTrailPopup(data: PastTrailData) {
        let longitude = data.positionData.longitude!;
        const latitude = data.positionData.latitude!;
        const mapCenter = this._map!.getView().getCenter()!;
        const [mapCenterLon] = transform(mapCenter, _PROJECTION, 'EPSG:4326');
        
        // normalizing longitudes to handle IDL crossing
        if (mapCenterLon < 0 && longitude > 0) {
            longitude -= 360;
        } else if (mapCenterLon > 0 && longitude < 0) {
            longitude += 360;
        }
        
        const position = fromLonLat([longitude, latitude], _PROJECTION);
        
        const popup = <VoyagePastTrailPopup>window.document.createElement('voyage-past-trail-popup');
        popup.data = data;
        
        const popupOverlay = new Overlay({
            position: position,
            positioning: 'top-left',
            element: popup,
            stopEvent: true,
        });
    
        const lineStyle = new Style({
            stroke: new Stroke({
                color: this._colors.pastTrailLineColor,
                width: 3,
                lineDash: [.1, 5],
            }),
            zIndex: 2
        });
    
        const lineFeature = new Feature({
            geometry: new LineString([position, position])
        });
        lineFeature.setStyle(lineStyle);
        popupOverlay.set("lineFeature", lineFeature);
    
        // checking for existing popup using normalized coordinates
        let preExistPopup = this._toolTipData.some(val => {
            const existingLon = val.positionData?.longitude!;
            const existingLat = val.positionData?.latitude!;
            return Math.abs(existingLat - latitude) < 0.0001 && 
                   Math.abs(existingLon - longitude) < 0.0001;
        });
    
        if (!preExistPopup) {
            this._toolTipData.push(data);
            this._pastTrailPopupVectorSource?.addFeature(lineFeature);
            
            popup.addEventListener(VoyagePastTrailPopupEvents.Close, 
                () => this._closePastTrailPopup(popupOverlay, popup, lineFeature));
            popup.addEventListener("mousedown", 
                (evt: MouseEvent) => this._mouseDownOnPastTrailPopup(evt, popupOverlay));
            popup.addEventListener("mouseup", 
                (evt: MouseEvent) => this._mouseUpOnPastTrailPopup(evt, popupOverlay));
    
            this._map?.addOverlay(popupOverlay);
            this._pastTrailOpenedPopups.add(popup);
            VoyagePastTrailModel!.highlightTableOnPastTrailClick(data);
        }
    }

    private _mouseUpOnPastTrailPopup(evt: MouseEvent, overlay: Overlay) {
        if (overlay.get('dragging') === true) {
            this._pastTrailDragPan!.setActive(true);
            overlay.set('dragging', false);
            this._pastTrailDraggedOverlay = null;
        }
    }

    private _mouseDownOnPastTrailPopup(evt: MouseEvent, overlay: Overlay) {
        this._pastTrailDragPan!.setActive(false);
        let markerpos = overlay.getPosition();
        let clickPixel = [evt.x, evt.y];
        let clickCoords = this._map!.getCoordinateFromPixel(clickPixel)

        this._pastTrailMouseDeltaX = clickCoords[0] - markerpos![0];
        this._pastTrailMouseDeltaY = clickCoords[1] - markerpos![1];

        overlay.set('dragging', true);
        this._pastTrailDraggedOverlay = overlay;
    }

    private _closePastTrailPopup(overlay: Overlay, element: VoyagePastTrailPopup, lineFeature: Feature<LineString>) {
        overlay.unset("lineFeature");
        this._map?.removeOverlay(overlay);
        this._pastTrailPopupVectorSource?.removeFeature(lineFeature);

		// Remove the corresponding data from tooltip array - which is used to avaoid multiple tooltip issue
		let indexToDelete = -1
		this._toolTipData.map((val,index) => {
			if(element?.data?.positionData?.latitude === val?.positionData?.latitude && element?.data?.positionData?.longitude === val.positionData?.longitude  ) {
				indexToDelete = index
			}})
		if(indexToDelete!==-1){
			this._toolTipData?.splice(indexToDelete, 1);
		}
    }

    private _updatePastTrail(evt: CustomEvent) {
        if (!this._highlightedImo) return;

        const trackData = VoyagePastTrailModel!.trackSegment;
        if (!trackData) {
            return
        }

        const currentVesselPosition = VesselsTrackingModel?.allVesselPositions.get(this._highlightedImo)
        let track = []
        for (const pos of trackData) {
            //excluding the psoition if the past trail time stamp exceeds the current vessel position
            if(currentVesselPosition?.timestamp && (pos.positionData!.timestamp > currentVesselPosition?.timestamp)){
                continue;                 
            }
            const val =  {
                timestamp: pos.positionData.timestamp,
                latitude: pos.positionData.latitude,
                longitude: pos.positionData.longitude,
                heading: pos.positionData.heading
                }
                track.push(val)              
         }      

        const features = trackToFeature(track, this._colors.pastTrailMarkerColor, "Past trail");
        features.forEach(f => f.set("name", null));
        this._pastTrailVectorSource!.clear();

        if (this._highlightedImo !== evt.detail.imo) {
            return;
        }

        this._pastTrailVectorSource!.addFeatures(features);

        const positionsFeatures: Feature<Geometry>[] = [];

        for (let i = 0; i < trackData.length; i++) {
            const position = new Feature(new Point([trackData[i].positionData.longitude!, trackData[i].positionData.latitude!]));
            position.getGeometry()?.transform('EPSG:4326', _PROJECTION);
            position.setStyle(this._pastTrailMarkerStyle(trackData[i], this._colors.pastTrailMarkerColor, 0.85));
            position.set("positionData", trackData[i]);
            position.set("layer", VoyageLayersNames.PastTrailLayer);
            positionsFeatures.push(position);
        }

        this._pastTrailVectorSource!.addFeatures(positionsFeatures);
        handleVectorRerender(this._map!, this._enablePastTrailTrack, this);
    }

    private _pastTrailMarkerStyle(positionData: PastTrailData, color: string, scale: number, focus?: boolean) {
        const markerShape = escape(`
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.96392 0L14 8H0L6.96392 0Z" fill="currentColor"/>
            </svg>
        `);

        const markerStyle = new Style({
            image: new Icon({
                src: 'data:image/svg+xml;utf8,' + markerShape.replace("currentColor", escape(color)),
                rotation: positionData?.positionData.heading! * 0.0174532925,
                rotateWithView: true,
                scale: scale,
                anchor: [.5, .5]
            })
        });

        return markerStyle;
    }

    private _groupTerminalsByCity(features: RenderFeature[] | Feature<Geometry>[]) {
        let grouppedTerminalsByCity = [];
        features.sort((a: FeatureLike, b: FeatureLike) => {
            let aProps = a.get('properties');
            let bProps = b.get('properties');
            return aProps.cityId.localeCompare(bProps.cityId);
        });

        for (let subfeature of features) {
            let props = subfeature.get('properties');
            if (grouppedTerminalsByCity.length === 0 || grouppedTerminalsByCity[grouppedTerminalsByCity.length - 1].city !== props.city) {
                grouppedTerminalsByCity.push({ city: props.city, cityId: props.cityId, terminals: [props] });
            } else {
                grouppedTerminalsByCity[grouppedTerminalsByCity.length - 1].terminals.push(props);
            }
        }

        return grouppedTerminalsByCity;
    }

    private _createPortPinTooltip() {
        this._portPinTooltipElement = <VoyMapTerminalTooltip>window.document.createElement('voy-map-terminal-tooltip');

        this._portPinTooltipOverlay = new Overlay({
            position: fromLonLat([0, 0], _PROJECTION),
            positioning: 'bottom-center',
            element: this._portPinTooltipElement,
            stopEvent: false,
            offset: [0, -18]
        });
        this._map?.addOverlay(this._portPinTooltipOverlay);
    }
};

